import { render, staticRenderFns } from "./qunSelection.vue?vue&type=template&id=596682e0&scoped=true"
import script from "./qunSelection.vue?vue&type=script&lang=js"
export * from "./qunSelection.vue?vue&type=script&lang=js"
import style0 from "./qunSelection.vue?vue&type=style&index=0&id=596682e0&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "596682e0",
  null
  
)

export default component.exports